// File: config/getStartedConfig.js
import GetStarted from "../Components/GetStarted/GetStarted.jsx";
import GetStarted2 from "../Components/GetStarted/GetStarted2.jsx";
import GetStarted3 from "../Components/GetStarted/GetStarted3.jsx";

import GetStarted4 from "../Components/GetStarted/GetStarted4.jsx";

const getStartedConfig = {
  getStarted: {
    route: "/get-started/step1",
    component: GetStarted,
    seo: {
      title: "Get Started - Step 1 | Matched Betting Crash Course",
      description: "Step 1 of the matched betting crash course. Learn the basics of matched betting.",
    },
    progress: {
      currentStep: 0,
      totalSteps: 4,
    },
  },
  getStarted2: {
    route: "/get-started/step2",
    component: GetStarted2,
    seo: {
      title: "Get Started - Step 2 | Matched Betting Crash Course",
      description:
        "Step 2 of the matched betting crash course. Explore the fundamentals of matched betting and essential strategies.",
    },
    progress: {
      currentStep: 1,
      totalSteps: 4,
    },
  },
  getStarted3: {
    route: "/get-started/step3",
    component: GetStarted3,
    seo: {
      title: "Get Started - Step 3 | Matched Betting Crash Course",
      description:
        "Step 3 of the matched betting crash course. Explore advanced techniques and strategies for matched betting.",
    },
    progress: {
      currentStep: 2,
      totalSteps: 4,
    },
  },
  getStartedEnd: {
    route: "/get-started/step4",
    component: GetStarted4,
    seo: {
      title: "Get Started - Step 4 | Matched Betting Crash Course",
      description:
        "Step 4 of the matched betting crash course. Explore advanced techniques and strategies for matched betting.",
    },
    progress: {
      currentStep: 2,
      totalSteps: 4,
    },
  },
};

export default getStartedConfig;
